import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { App } from "antd";

export const useAddParticipant = () => {

    const axios = useAxios();
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const {message} = App.useApp();

    const addParticipant = async (participant: any) => {
        try {
            const response = await axios.post("/api/participant", participant);
            return response.data;
        } catch (error: any) {
            const serverMessage = error?.response?.data?.Message;
            throw new Error(serverMessage || t("messages.error.addParticipant"));
        }
    }

    return useMutation({ mutationFn: addParticipant, onSuccess: (data: any) => {
        queryClient.invalidateQueries({ queryKey: ["participants"] });
        if (data?.existingUserAdded) {
            message.info(t("messages.info.existingParticipantAdded"));
            return;
        }

        message.success(t("messages.success.addParticipant"));
    }, onError: (error: Error) => {
        message.error(error.message);
    }});
}